import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not authed

  const checkAuth = useCallback(async () => {
    // If we're on an OAuth callback, skip check
    if (window.location.hash?.includes("session_id=")) {
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(async (email, password, headers) => {
    const { data } = await api.post("/auth/login", { email, password }, headers ? { headers } : undefined);
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (name, email, password, headers) => {
    const { data } = await api.post("/auth/register", { name, email, password }, headers ? { headers } : undefined);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    setUser(null);
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {}
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, checkAuth, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
